<template>
    <div class="wrap">
        <div>
          <div>参与步骤：</div>
          <div>1.点击“立即参与”进入小程序</div>
          <div>2.根据提示咨询问题</div>
          <div style="margin-bottom: 20px">3.创建就诊人信息，继续追问完成体验流程</div>






          联系微信号领取奖励金: <br>
          yihudaojia2022
          <div @click="toUrl" style="margin-top: 20px"> ➡️点击直达活动页面</div>
        </div>
    </div>
</template>

<script>
import { onMounted, ref, computed,reactive ,toRaw} from "vue"
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { Dialog } from 'vant'
import homeApi from '@axios/home'
export default {
  name: "participate",
  setup(){
    const route = useRoute()
    const phone = route.query.phone ?  route.query.phone : ''

    let urls = ref('');
    const getInfo = () => {
      let formData = new FormData();
      formData.append('data', JSON.stringify({
        function: "getWeiLaiUrl",
        phone:phone,
      }))
      formData.append('encryption', false)

      homeApi.getList(formData).then((res)=> {
        console.log('res',res)
        urls.value = res.data;
      })
    }
    getInfo();

    const toUrl = () => {
      if(urls.value){
        window.location.href = urls.value;
      }

    }
    return {
      toUrl,
    }
  }
}
</script>

<style scoped lang="scss">
  .wrap{
    box-sizing: border-box;
    padding:40px;
    font-size: 32px;
  }
</style>
